import { getImgBaseUrl } from '@/utils/imageUrls/getImgBaseUrl';
import { ImageParams, stringifyImageParams } from '@/utils/imageUrls/stringifyImageParams';

export function getStickerImageUrl(designId: string, params: ImageParams) {
  return `${getImgBaseUrl().slice(0, -1)}2/designs/${designId}/sticker${stringifyImageParams(
    params
  )}`;
}
